import { createStore } from 'vuex'
import core from './core'
import cart from './modules/cart';
import auth from './modules/auth';
import sponsors from './modules/sponsors';
import messages from './modules/messages';

import * as actions from './actions';

export const store = createStore({
  actions,
  modules: {
    auth,
    core,
    cart,
    sponsors,
    messages
  },
})